import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const HKIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="HK" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#EA1A1A"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <G filter="url(#c)">
          <Path
            fill="#fff"
            d="M9.12 5.914c.029.008 3.705 1.124 1.223 3.938-.008-.003-1.379-.583-1.224-2.025.156-1.446.445-1.758 0-1.913Zm-.977.867s.666 3.82-2.976 2.855c-.001-.019-.09-1.496 1.264-2 1.363-.507 1.771-.388 1.712-.855Zm-4.48-2.847s1.44-.403 2.216.827c.776 1.23.743 1.654 1.188 1.5-.046.018-3.602 1.41-3.405-2.327ZM8.636 5.56c.015-.028 1.834-3.41 4.102-.42-.014.02-.851 1.233-2.226.798-1.387-.438-1.636-.783-1.876-.378Zm-.143-3.857S9.5 2.81 8.745 4.054c-.754 1.244-1.148 1.404-.81 1.734 0 0-2.895-2.582.56-4.086Z"
          />
        </G>
        <Path
          stroke="#EA1A1A"
          strokeWidth={0.5}
          d="M5.08 5.104S5.81 6.25 7 6.25M7.93 3.525s-.653 1.205-.093 2.258M11.055 4.88s-1.525-.23-2.323.656M10.164 7.672S9.86 6.16 8.754 5.714M6.967 8.493S8.284 7.69 8.325 6.5"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
